module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/outgoing-call-eea6fe6fc049d9169f3f668b6d06ebd2.svg";